const {PRIME_MAKE} = require('./MakeConstant')

class Make {

    constructor({
                    id = '',
                    name = '',
                    website = '',
                    logo = ''
                } = {}) {

        this.id = id;
        this.name = name;
        this.website = website;
        this.logo = logo;
    }

    static get PRIME_MAKE() {
        return PRIME_MAKE
    };

    validate(attribute) {

        if (attribute === undefined) {
            const attributes = Object.keys(this);
            try {
                attributes.map(attribute => {
                    if (!this._validate(attribute)) {
                        throw "validation error"
                    }
                });
            } catch (e) {
                return false
            }
            return true
        }

        return this._validate(attribute)
    }

    _validate(attribute) {

        try {
            switch (attribute) {
                case 'id':
                    return (typeof this[attribute] === 'string');
                default:
                    return false
            }
        } catch (e) {
            console.error('Validating Make with error:', e, attribute);
            return false
        }
    }

    toFirestore() {

        return {
            id: this.id,
            name: this.name,
            website: this.website,
            logo: this.logo
        }
    }

    static fromFirestore(fsSnap) {

        let data = {};
        if (fsSnap) {
            Object.keys(fsSnap).forEach((key) => {
                // the firestore object is not null
                if (fsSnap[key]) {
                    data[key] = new Make({...fsSnap[key], id: key})
                }
            });
        }

        return data
    }

    isSame(object) {

        return Object.is(
            JSON.stringify(object),
            JSON.stringify(this))
    }
}

module.exports = Make;